<template>
  <div>

    <div class="video-img-box" >
      <div
        v-if="showRank && video.rank"
        class="video-block-rank"
        :class="{'unrank': video.rank > 3}">
        <img :src="require(`@/assets/images/rank/${video.rank > 3 ? 'unrank': video.rank}.png`)">
        <span class="video-block-rank-text">{{video.rank > 3 ? video.rank : ''}}</span>
      </div>
      <base-image
        class="video-item-img"
        :ratio="750/422"
        :url="useEncryptBigImage(video.coverbase64.url)"
        :type="video.coverbase64.type"
        encrypt/>
      <div class="video-info">
        <div class="video-info-item">
          <img src="@/assets/images/mine/icon_day.png" />{{
            timeRender(video.updated_at)
          }}
        </div>
        <div class="video-info-item">
          <img src="@/assets/images/mine/icon_fire.png" />
          {{ (video.pageviews / 10000).toFixed(0) + "万" }}
        </div>
        <div class="video-info-item">
          <img src="@/assets/images/mine/icon_time.png" />{{
            video.playtimes
          }}
        </div>
      </div>
    </div>
    <div class="video-title">{{ video.title }}</div>
  </div>
</template>

<script>
import { timeRender, useEncryptBigImage } from '@/utils/index'
import baseImage from '@/components/baseImage'

export default {
  name: 'findVideoBlock',
  components: {
    baseImage
  },
  props: {
    video: {
      type: Object,
      default: function () {
        return {
          coverbase64: {
            type: null,
            url: null
          },
          created_at: '',
          updated_at: '',
          id: null,
          pageviews: null,
          playtimes: '',
          title: '',
          rank: null
        }
      }
    },
    showRank: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    useEncryptBigImage,
    timeRender
  }
}
</script>

<style scoped>
.video-item-img {
  width: 100%;
  min-height: 163px;
}

.video-title {
  padding: 5px;
  margin-bottom: 15px;
  font-size: 14px;
  color: #fff;
  text-align: left;
}

.video-img-box {
  position: relative;
}

.video-info {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  padding: 5px;
  background-color: rgba(0, 0, 0, 0.6);
}

.video-info div {
  color: #fff;
}

.video-info div:nth-child(2) {
  flex: 1;
}

.video-info-item {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.video-info-item img {
  width: 16px;
  margin-right: 8px;
  margin-left: 8px;
}

.video-block-rank {
  position: absolute;
  left: 0;
  z-index: 10;
}

.video-block-rank.unrank {
  top: 7px;
  left: 7px;
}

.video-block-rank-text {
  position: absolute;
  top: 7px;
  left: 0;
  width: 34px;
  height: 35px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/find/components/videoBlock.vue